import { PopperController } from "./popper";

export class PopperHoverTriggerController {
  public popperCtrl: PopperController;

  /**
   * True if the mouse is over the popper content of this trigger.
   */
  public isChildHovered: boolean;

  /**
   * True if trigger is allowed to be open.
   */
  public isAllowed: boolean;

  private readonly HOVER_DELAY: number = 200;
  // @ngInject
  constructor(private $timeout: ng.ITimeoutService) {}

  public handlePopperMouseEvent($event: any) {
    if (!this.isAllowed) {
      return;
    }
    this.$timeout(() => {
      if ($event.type === "mouseover") {
        if (!this.popperCtrl.isVisible) {
          this.togglePopper($event);
        }
      } else if (this.popperCtrl.isVisible && !this.isChildHovered) {
        this.togglePopper($event);
      }
    }, this.HOVER_DELAY);
  }

  public togglePopper($event: any) {
    this.popperCtrl.togglePopper();
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
  }
}

export const sdPopperHoverTrigger: ng.IComponentOptions = {
  controller: PopperHoverTriggerController,
  require: {
    popperCtrl: "^sdPopper"
  },
  bindings: {
    isChildHovered: "<",
    isAllowed: "<"
  },
  transclude: true,
  template:
    '<div class="sd-popper-trigger" ng-mouseleave="$ctrl.handlePopperMouseEvent($event)" ng-mouseenter="$ctrl.handlePopperMouseEvent($event)" keyboard-activation="$ctrl.togglePopper()" tabindex="0"><ng-transclude></ng-transclude></div>'
};
